module.exports = __webpack_public_path__ + "static/media/Dayflow - Success Notification.7126587b.png";